import { useMemo } from 'react';
import { ScanDateOption, ScanMetadata } from '../../interfaces/scanMetadata';
import { getScanDateOptions } from '../../utils/getScanDateOptions/getScanDateOptions';

export const useScanDateOptions = (scansMetadata: ScanMetadata[]): ScanDateOption[] => {
  return useMemo(() => getScanDateOptions(scansMetadata), [scansMetadata]);
};
